import React from 'react';
import LoggingContext from '../../../Contexts/Logging/Context';

/**
 * Wraps a ComponentType with a binding to a log implementation for LoggingContext.Consumer as a property.
 * ComponentType should expect a PropType name log.
 * @param WrappedComponent
 * @returns {*}
 */
function withLog(WrappedComponent) {
    // eslint-disable-next-line react/display-name,react/no-multi-comp
    let componentClass = class extends React.Component {
        constructor(props) {
            super(props);
        }

        render() {
            return (
                <LoggingContext.Consumer>
                    {(log) => <WrappedComponent log={log} {...this.props} />}
                </LoggingContext.Consumer>
            );
        }
    };

    let {log, ...propTypes} = WrappedComponent.propTypes;
    componentClass.propTypes = propTypes;

    return componentClass;
}

export default withLog;
